<script setup>
import { ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';
import NextButton from 'dashboard/components-next/button/Button.vue';
import Switch from 'dashboard/components-next/switch/Switch.vue';

const props = defineProps({
  phoneNumber: {
    type: String,
    default: '',
  },
  whatsappNotificationsEnabled: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['updateAgentWhatsapp']);

const { t } = useI18n();

const mobileNumber = ref(props.phoneNumber ?? '');
const notificationsEnabled = ref(props.whatsappNotificationsEnabled ?? false);

watch(
  () => props.phoneNumber ?? '',
  newValue => {
    mobileNumber.value = newValue;
  }
);
watch(
  () => props.whatsappNotificationsEnabled ?? false,
  newValue => {
    notificationsEnabled.value = newValue;
  }
);

const save = () => {
  if (mobileNumber.value && !/^\+[1-9]\d{6,14}$/.test(mobileNumber.value)) {
    useAlert(t('PROFILE_SETTINGS.FORM.AGENT_WHATSAPP_SECTION.INVALID_NUMBER'));
    return;
  }
  emit('updateAgentWhatsapp', {
    phoneNumber: mobileNumber.value,
    whatsappNotificationsEnabled: notificationsEnabled.value,
  });
};
</script>

<template>
  <form class="flex flex-col gap-4" @submit.prevent="save">
    <woot-input
      v-model="mobileNumber"
      :label="t('PROFILE_SETTINGS.FORM.AGENT_WHATSAPP_SECTION.MOBILE_LABEL')"
      placeholder="+919876543210"
    />
    <div class="flex items-center justify-between gap-4">
      <div class="flex-1 min-w-0">
        <h4 class="text-sm font-medium text-n-slate-12">
          {{
            t(
              'PROFILE_SETTINGS.FORM.AGENT_WHATSAPP_SECTION.NOTIFICATIONS_LABEL'
            )
          }}
        </h4>
        <p class="text-sm text-n-slate-11 mt-0.5">
          {{
            t('PROFILE_SETTINGS.FORM.AGENT_WHATSAPP_SECTION.NOTIFICATIONS_NOTE')
          }}
        </p>
      </div>
      <Switch v-model="notificationsEnabled" />
    </div>
    <div>
      <NextButton type="submit" :label="t('PROFILE_SETTINGS.BTN_TEXT')" />
    </div>
  </form>
</template>
